import type { ReactNode } from 'react';
import { cn } from '../cn.js';

export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded border border-border bg-surface px-1 text-[10px] font-medium text-muted shadow-panel',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
